import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { approveOrder } from '../../../shared/api/orders.api'

function extractError(e: unknown): string {
  const err = e as { response?: { data?: { error?: { message?: string } } } }
  return err.response?.data?.error?.message ?? 'Не удалось сохранить решение'
}

export function ApproveOrderModal({
  orderId,
  onClose,
  overrideMode = false,
}: {
  orderId: string
  onClose: () => void
  // Б7: режим переопределения отказа администратором (заказ в «Отказ» →
  // одобрение вернёт в «Подтверждён»; кнопка «Отклонить» не нужна).
  overrideMode?: boolean
}) {
  const qc = useQueryClient()
  const [note, setNote] = useState('')
  const [error, setError] = useState<string | null>(null)

  const mutation = useMutation({
    mutationFn: (approve: boolean) => approveOrder(orderId, { approve, note: note.trim() || null }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['orders', orderId] })
      void qc.invalidateQueries({ queryKey: ['orders'] })
      onClose()
    },
    onError: (e) => setError(extractError(e)),
  })

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-sm rounded-xl bg-white p-5 shadow-xl">
        <h3 className="mb-1 text-lg font-semibold">
          {overrideMode ? 'Вернуть заказ в работу' : 'Согласование заказа'}
        </h3>
        <p className="mb-3 text-sm text-gray-500">
          {overrideMode
            ? 'Заказ отклонён. Одобрение переопределит отказ и вернёт заказ в «Подтверждён», причина отказа будет очищена.'
            : 'Заказ с предоплатой меньше 50%. Одобрите для перехода в «Подтверждён» или отклоните (нужна причина).'}
        </p>
        <label className="mb-3 block text-sm">
          <span className="mb-1 block font-medium text-gray-700">Комментарий / причина</span>
          <textarea
            className="w-full rounded border border-gray-300 px-2 py-1.5"
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </label>
        {error && <p className="mb-3 text-sm text-red-600">{error}</p>}
        <div className="flex justify-end gap-2">
          <button className="rounded-lg px-3 py-1.5 text-sm text-gray-600" onClick={onClose}>
            Отмена
          </button>
          {!overrideMode && (
            <button
              className="rounded-lg bg-red-100 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-200 disabled:opacity-60"
              onClick={() => {
                setError(null)
                mutation.mutate(false)
              }}
              disabled={mutation.isPending}
            >
              Отклонить
            </button>
          )}
          <button
            className="rounded-lg bg-green-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-green-700 disabled:opacity-60"
            onClick={() => {
              setError(null)
              mutation.mutate(true)
            }}
            disabled={mutation.isPending}
          >
            Одобрить
          </button>
        </div>
      </div>
    </div>
  )
}
